/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_EyebrowInputs */

const en_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Corner`)
};

const es_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El rincón`)
};

const de_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ecke`)
};

const zh_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角落`)
};

const ar_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الركن`)
};

const fr_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le coin`)
};

const vi_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Góc tường`)
};

const sw_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kona`)
};

const th_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เดอะคอร์เนอร์`)
};

const bs_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugao`)
};

const ja_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーナー`)
};

const ko_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 코너`)
};

const pt_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Canto`)
};

const it_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'angolo`)
};

const sv_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corner`)
};

const nl_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De hoek`)
};

const da_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjørnet`)
};

const nb_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjørnet`)
};

const fi_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulma`)
};

const pl_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kącik`)
};

const ru_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уголок`)
};

const tr_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Köşe The Corner`)
};

const hi_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉर्नर`)
};

const id_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pojok`)
};

const ms_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudut Kenangan`)
};

const cs_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Corner`)
};

const el_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Γωνία`)
};

const he_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפינה`)
};

const af_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Hoek`)
};

const hu_hof_eyebrow = /** @type {(inputs: Hof_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sarok`)
};

/**
* | output |
* | --- |
* | "The Corner" |
*
* @param {Hof_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_eyebrow = /** @type {((inputs?: Hof_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_eyebrow(inputs)
	if (locale === "de") return de_hof_eyebrow(inputs)
	if (locale === "zh") return zh_hof_eyebrow(inputs)
	if (locale === "ar") return ar_hof_eyebrow(inputs)
	if (locale === "fr") return fr_hof_eyebrow(inputs)
	if (locale === "vi") return vi_hof_eyebrow(inputs)
	if (locale === "sw") return sw_hof_eyebrow(inputs)
	if (locale === "th") return th_hof_eyebrow(inputs)
	if (locale === "bs") return bs_hof_eyebrow(inputs)
	if (locale === "ja") return ja_hof_eyebrow(inputs)
	if (locale === "ko") return ko_hof_eyebrow(inputs)
	if (locale === "pt") return pt_hof_eyebrow(inputs)
	if (locale === "it") return it_hof_eyebrow(inputs)
	if (locale === "sv") return sv_hof_eyebrow(inputs)
	if (locale === "nl") return nl_hof_eyebrow(inputs)
	if (locale === "da") return da_hof_eyebrow(inputs)
	if (locale === "nb") return nb_hof_eyebrow(inputs)
	if (locale === "fi") return fi_hof_eyebrow(inputs)
	if (locale === "pl") return pl_hof_eyebrow(inputs)
	if (locale === "ru") return ru_hof_eyebrow(inputs)
	if (locale === "tr") return tr_hof_eyebrow(inputs)
	if (locale === "hi") return hi_hof_eyebrow(inputs)
	if (locale === "id") return id_hof_eyebrow(inputs)
	if (locale === "ms") return ms_hof_eyebrow(inputs)
	if (locale === "cs") return cs_hof_eyebrow(inputs)
	if (locale === "el") return el_hof_eyebrow(inputs)
	if (locale === "he") return he_hof_eyebrow(inputs)
	if (locale === "af") return af_hof_eyebrow(inputs)
	if (locale === "hu") return hu_hof_eyebrow(inputs)
	return en_hof_eyebrow(inputs)
});